import { isMobileEnv, isPcEnv } from './common'
import * as queryString from 'query-string'
import { isEmptyObject } from './logic/object'
import hostConfig from '../config'
import { isBrowser } from './index'

const naverLoginURL = 'https://nid.naver.com/nidlogin.login'
const naverLogoutURL = 'https://nid.naver.com/nidlogin.logout'
const naverRealNameAuthMobileURL = 'https://nid.naver.com/mobile/user/help/realNameCheck.nhn?type=3'
const naverRealNameAuthPCURL = 'https://nid.naver.com/user2/help/realNameCheck.nhn?type=3'
const naverUserProfileEditURL = 'https://nid.naver.com/user2/api/route.nhn'
const shoppingWebUri = hostConfig.shoppingWebUri[process.env.PROJECT_NAME]
const shoppingWebBaseURL = `${shoppingWebUri.protocol}://${shoppingWebUri.host}`

export const checkAndGoNaverLogin = () => {
  if (document.cookie.includes('NID_SES')) {
    return true
  }
  if (confirm('로그인이 필요한 서비스입니다. 로그인하시겠습니까?')) {
    window.location.href = getNaverLoginURL()
  }
  return false
}

export const getNaverLoginURL = (requestPath?: string) => {
  let currentURL
  if (requestPath) {
    currentURL = encodeURIComponent(`${shoppingWebBaseURL}${requestPath}`)
  } else if (isBrowser) {
    currentURL = encodeURIComponent(window.location.href)
  }
  if (isMobileEnv) {
    return `${naverLoginURL}?svctype=262144&mode=form&url=${currentURL}`
  }
  return `${naverLoginURL}?mode=form&url=${currentURL}`
}

export const getNaverPopupLoginURL = (params?: Object) => {
  const url = `${naverLoginURL}?svctype=64&url=${encodeURIComponent(
    `${window.location.protocol}//${window.location.hostname}/redirect/login`,
  )}`
  let queryParams = ''
  if (params && !isEmptyObject(params)) {
    queryParams = `?${encodeURIComponent(queryString.stringify(params))}`
  }

  return `${url}${queryParams}`
}

export const getNaverPopupLoginUrlWithLocation = (location: Location) => {
  return `${naverLoginURL}?svctype=64&url=${encodeURIComponent(location.href)}`
}

export const getNaverLogoutURL = () => {
  const currentURL = encodeURIComponent(window.location.href)
  return `${naverLogoutURL}?returl=${currentURL}`
}

export const getRealNameAuthURL = () => {
  const currentURL = encodeURIComponent(window.location.href)
  return `${isPcEnv ? naverRealNameAuthPCURL : naverRealNameAuthMobileURL}&rurl=${currentURL}`
}

export const getProfileEditURL = () => {
  const currentURL = encodeURIComponent(window.location.href)
  return `${naverUserProfileEditURL}?fromService=shoppingmy&m=${
    isPcEnv ? 'routePcProfileModification' : 'routeMobileProfileModification'
  }&returnUrl=${currentURL}`
}
